import { render, staticRenderFns } from "./PortalNotes.vue?vue&type=template&id=109bcea5&scoped=true"
import script from "./PortalNotes.vue?vue&type=script&lang=js"
export * from "./PortalNotes.vue?vue&type=script&lang=js"
import style0 from "./PortalNotes.vue?vue&type=style&index=0&id=109bcea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109bcea5",
  null
  
)

export default component.exports